import { render, staticRenderFns } from "./MISPostalFeeReport.vue?vue&type=template&id=4ed2e922&scoped=true"
import script from "./MISPostalFeeReport.vue?vue&type=script&lang=js"
export * from "./MISPostalFeeReport.vue?vue&type=script&lang=js"
import style0 from "./MISPostalFeeReport.vue?vue&type=style&index=0&id=4ed2e922&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed2e922",
  null
  
)

export default component.exports